export default __webpack_public_path__ + "static/media/coffeechat2.713e5067.png";